module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alert-info":"Maintenance in progress."},"es":{"alert-info":"Mantenimiento en curso."},"fr":{"alert-info":"Maintenance en cours."},"it":{"alert-info":"Manutenzione in corso."},"pt":{"alert-info":"Manutenção em curso."},"pl":{"alert-info":"Konserwacja w toku."}}')
  delete Component.options._Ctor
}
